import { AppState } from '../state/appState';
import {
	CallAudioUpload,
	CallAudioUploadCallIdentifier,
	CallAudioUploadFailure,
	CallAudioUploadStatus
} from '../state/callAudioUploadState';
import { CallDetails } from '../../models/dto/call';
import { doCallAudioIdentifiersMatch } from '../../helpers/jobHelpers';

export function getJobUploadFileLists(state: AppState, jobId: number): JobUploadFileListWithManifest | JobUploadFileListWithoutManifest {
	const job = state.jobs.details.get(jobId);
	if (!job)
		return { type: 'withoutManifest', files: [] };
	
	if (job.createdWithoutCallManifest) {
		return {
			type: 'withoutManifest',
			files: [
				...(job.calls ?? []).filter(c => !!c.tethrCallId).map<JobUploadFile>(c => ({ type: 'uploaded', details: c })),
				...state.callAudioUpload.uploads.filter(u => u.jobId === job.id).map<JobUploadFile>(u => ({ type: 'uploading', details: u })),
				...state.callAudioUpload.failures.filter(u => u.jobId === job.id).map<JobUploadFile>(f => ({ type: 'failure', details: f }))
			]
		}		
	} else {
		return {
			type: 'withManifest',
			pending: (job.calls?.filter(c => !c.tethrCallId) ?? []).map<PendingJobUploadFile>(call => {
				const callIdentifier: CallAudioUploadCallIdentifier = { type: 'call', id: call.id, filename: call.fileName };

				return {
					call,
					upload: state.callAudioUpload.uploads.find(u => u.jobId === jobId && doCallAudioIdentifiersMatch(u.callIdentifier, callIdentifier, true))
				};
			}),
			uploaded: job.calls?.filter(c => !!c.tethrCallId) ?? [],
			failed: state.callAudioUpload.failures.filter(f => f.jobId === jobId)
		}
	}
}

export interface JobUploadFileListWithManifest {
	type: 'withManifest';
	pending: PendingJobUploadFile[];
	uploaded: CallDetails[];
	failed: CallAudioUploadFailure[];
}

export interface PendingJobUploadFile {
	call: CallDetails;
	upload: CallAudioUpload | nundefined;
}

export interface JobUploadFileListWithoutManifest {
	type: 'withoutManifest';
	files: JobUploadFile[];
}

export type JobUploadFile = { type: 'failure'; details: CallAudioUploadFailure; } | { type: 'uploading'; details: CallAudioUpload; } | { type: 'uploaded'; details: CallDetails; };